
import Vue from 'vue'
export default {

}

Vue.filter('time', (value) => {
    if (!value) {
        return '--'
    }
    var date = new Date(value)
    var Y = date.getFullYear() 
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) 
    var D = date.getDate() > 9 ? date.getDate() : ('0' + date.getDate()) 
    var h = date.getHours() > 9 ? date.getHours() : ('0' + date.getHours()) 
    var m = date.getMinutes() > 9 ? date.getMinutes() : ('0' + date.getMinutes()) 
    var s = date.getSeconds() > 9 ? date.getSeconds() : ('0' + date.getSeconds())
    return Y + '-' + M + '-' + D + ' ' + h + ':' + m + ':' + s
 })

Vue.filter('timeYMD', (value) => {
    if (!value) {
        return '--'
    }
    var date = new Date(value)
    var Y = date.getFullYear() 
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) 
    var D = date.getDate() > 9 ? date.getDate() : ('0' + date.getDate()) 
    return Y + '-' + M + '-' + D 
})
// Vue.filter('oddTime',(nowTime,endTime) => {
//     if(!nowTime || !endTime){
//         return '--'
//     }
//     let beginDateStr=nowTime.split(" ");
//     let beginStrGMT = beginDateStr[0]+" "+beginDateStr[1]+" "+beginDateStr[2]+" "+beginDateStr[5]+" "+beginDateStr[3]+" GMT+0800";

//     let endDateStr=endTime.split(" ");
//     let endStrGMT = endDateStr[0]+" "+endDateStr[1]+" "+endDateStr[2]+" "+endDateStr[5]+" "+endDateStr[3]+" GMT+0800";

//     let time = (new Date(endStrGMT).getTime() - new Date(beginStrGMT).getTime())/1000;

//     let day = Math.floor(time/(60*60*24));
//     let hour = Math.floor(time/(60*60)) - (day * 24);
//     let min = Math.floor(time/(60)) - (day * 24 * 60) - (hour * 60);
//     let sen = Math.floor(time) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (min * 60);
//     return day + '天' + hour + '时' + min + '分' + sen + '秒';
// });
// Vue.filter('msTo',(value) => {
//     if(!value){
//         return
//     }
//     let time = value;
//     let day = 0;
//     let hour = 0;
//     let min = 0;
//     let sen = 0;
//     if(time >= 0){

//         sen = (time / 1000).toFixed(3);
//         if(sen >= 60){
//             min = parseInt(sen / 60);
//             sen = (sen%60).toFixed(3);
//             if(min >= 60){
//                 hour = parseInt(min / 60);
//                 min = Math.floor(min%60)
//                 if(hour >= 24){
//                     day = parseInt(hour / 24);
//                     hour = Math.floor(hour%24)
//                 }
//             }
//         }

//         if(day > 1){
//             return day + '天' + hour + '时' + min + '分' + sen + '秒';
//         }else if(day < 1 && hour > 1){
//             return hour + '时' + min + '分' + sen + '秒';
//         }else if(day < 1 && hour < 1 && min > 1){
//             return min + '分' + sen + '秒';
//         }else{
//             return sen + '秒';
//         }

//     }else{
//         return '0秒';
//     }
// });
Vue.filter('timeYMD2', (value) => {
    if (!value) {
        return '--'
    }
    var date = new Date(value)
    var Y = date.getFullYear() 
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) 
    var D = date.getDate() > 9 ? date.getDate() : ('0' + date.getDate()) 
    return Y + '/' + M + '/' + D 
})
Vue.filter('valueIsNull', (value) => {
    if (value == '0') {
        return value
    } else if (value && value != '' && value != 'null' && value != 'undefined' && value != 'Null') {
        return value
    } else {
        return '---'
    }
})
Vue.filter('valueIsNullToZero', (value) => {
    if (value == '0') {
        return value
    } else if (value && value != '' && value != 'null' && value != 'undefined' && value != 'Null') {
        return value
    } else {
        return '0'
    }
})